module.exports = __webpack_public_path__ + "static/media/google-play-badge.dcc565bf.png";